var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoKrGora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 42,
    viewBox: "0 0 187 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.54 13.5444C114.496 13.5444 114.312 13.4822 113.268 13.4822C112.838 13.4822 112.409 13.6686 112.163 13.9793C108.05 18.8254 100.99 27.9586 100.99 27.9586C100.621 28.3935 100.806 28.7663 101.42 28.7663H101.604C102.954 28.7663 103.384 28.4556 103.814 28.0207C103.814 28.0207 112.347 19.9438 116.522 15.5947C117.259 14.787 116.645 13.5444 115.54 13.5444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.03 13.5444C121.986 13.5444 121.802 13.4822 120.758 13.4822C120.328 13.4822 119.899 13.6686 119.653 13.9793C115.601 18.8876 108.541 27.9586 108.541 27.9586C108.173 28.3935 108.357 28.7663 108.971 28.7663H109.155C110.506 28.7663 110.935 28.4556 111.365 28.0207C111.365 28.0207 119.899 19.9438 124.073 15.5947C124.749 14.787 124.196 13.5444 123.03 13.5444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6838 26.716V14.8491L56.3578 22.3047V15.284H58.5679V27.1509L50.9553 19.571V26.716H48.6838Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4888 26.6539V24.7278C59.7344 24.7899 59.98 24.8521 60.1641 24.9142C60.3483 24.9763 60.4711 24.9763 60.6553 24.9763C60.8395 24.9763 60.9622 24.9763 61.1464 24.9763C62.1901 24.9763 62.9882 24.6657 63.4793 24.0444C63.7249 23.7337 63.8477 23.4231 63.9091 23.1124C63.9704 22.7396 64.0318 22.1805 64.0318 21.3728V15.284H66.3033V22.1805C66.3033 22.7396 66.242 23.2367 66.1806 23.6095C66.1192 24.0444 65.935 24.355 65.7508 24.7278C65.5666 25.0385 65.3211 25.3491 65.0141 25.6598C64.5844 26.0325 64.0932 26.3432 63.4179 26.5917C62.804 26.8402 62.1287 26.9024 61.392 26.9024C61.085 26.9024 60.7781 26.9024 60.5325 26.8402C60.3483 26.8402 59.98 26.7781 59.4888 26.6539Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7154 26.5917V24.7899C68.2679 24.8521 68.5749 24.9142 68.6362 24.9142C69.3729 24.9763 70.0483 25.0385 70.6622 25.0385C71.7672 25.0385 72.6267 24.9142 73.1179 24.7278C73.6704 24.4793 73.916 24.1686 73.916 23.6716C73.916 23.4231 73.8546 23.2367 73.7318 23.1124C73.609 22.926 73.3634 22.8018 73.1179 22.6154C72.8723 22.4911 72.2584 22.2426 71.2761 21.8077C70.7236 21.5592 70.3552 21.4349 70.1096 21.2485C69.8641 21.1243 69.5571 20.9379 69.2502 20.7515C68.8204 20.4408 68.4521 20.068 68.2679 19.6953C68.0223 19.2604 67.9609 18.8254 67.9609 18.3284C67.9609 17.2722 68.3907 16.4645 69.2502 15.9675C70.1097 15.4083 71.3375 15.1598 72.9951 15.1598C73.3634 15.1598 73.7932 15.1598 74.2229 15.2219C74.7754 15.2219 75.328 15.284 75.8805 15.4083V17.2101C75.6349 17.2101 75.5121 17.1479 75.3894 17.1479C75.328 17.1479 75.2052 17.1479 75.1438 17.1479C74.5299 17.0858 73.8546 17.0237 73.1179 17.0237C72.1356 17.0237 71.4603 17.1479 70.9691 17.3343C70.478 17.5207 70.2938 17.8314 70.2938 18.2663C70.2938 18.639 70.5394 18.9497 70.9691 19.1982C71.2761 19.3846 71.8286 19.6331 72.6267 20.0059C73.0565 20.1923 73.4248 20.3166 73.6704 20.4408C74.1001 20.6272 74.5299 20.8136 74.8368 21.0621C75.3894 21.3728 75.7577 21.7456 76.0033 22.1805C76.2488 22.6154 76.433 23.1124 76.433 23.6716C76.433 24.4172 76.2488 24.9763 75.8191 25.4734C75.3894 25.9704 74.8368 26.3432 74.0387 26.5917C73.2406 26.8402 72.2584 26.9645 71.0919 26.9645C70.7236 26.9645 70.2324 26.9645 69.6185 26.9024C69.2502 26.9024 68.9432 26.8402 68.6976 26.8402C68.3907 26.716 68.0837 26.6538 67.7154 26.5917Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7469 26.716H89.3867L93.5 19.1361L97.6747 26.716H100.253L93.5 14.8491L86.7469 26.716Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0607 27.0266L95.8943 24.8521C94.4823 26.716 93.5 27.9586 93.5 27.9586C93.1316 28.3935 93.3158 28.7663 93.9297 28.7663H94.1139C95.4645 28.7663 95.8943 28.4556 96.324 28.0207C96.324 28.0207 96.631 27.7101 97.1835 27.213L97.0607 27.0266Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.989 13.5444C106.945 13.5444 106.761 13.4822 105.717 13.4822C105.287 13.4822 104.858 13.6686 104.612 13.9793C102.832 16.1538 100.376 19.1982 98.2886 21.8698L99.8848 24.6657C102.709 21.9319 106.638 18.142 109.032 15.6568C109.707 14.787 109.155 13.5444 107.989 13.5444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.492 21C135.492 20.1302 135.615 19.3225 135.922 18.5769C136.229 17.8313 136.659 17.21 137.211 16.713C137.764 16.1538 138.439 15.7811 139.176 15.4704C139.912 15.1598 140.772 15.0355 141.693 15.0355C142.552 15.0355 143.412 15.1598 144.148 15.4704C144.885 15.7811 145.56 16.1538 146.113 16.713C146.665 17.2722 147.095 17.8935 147.402 18.5769C147.709 19.3225 147.832 20.1302 147.832 21C147.832 21.8698 147.709 22.6775 147.402 23.3609C147.095 24.1065 146.665 24.7278 146.113 25.2248C145.56 25.784 144.885 26.1568 144.148 26.4674C143.412 26.7781 142.552 26.9024 141.693 26.9024C140.772 26.9024 139.974 26.7781 139.176 26.4674C138.439 26.1568 137.764 25.784 137.211 25.2248C136.659 24.6657 136.229 24.0444 135.922 23.2988C135.676 22.6775 135.492 21.8698 135.492 21ZM141.754 17.0237C141.017 17.0237 140.342 17.21 139.728 17.5207C139.114 17.8313 138.685 18.3284 138.316 18.9497C138.009 19.571 137.825 20.2544 137.825 21C137.825 21.7456 138.009 22.429 138.316 23.0503C138.623 23.6716 139.114 24.1065 139.728 24.4793C140.342 24.7899 141.017 24.9763 141.754 24.9763C142.491 24.9763 143.166 24.7899 143.78 24.4793C144.394 24.1686 144.824 23.6716 145.192 23.0503C145.499 22.429 145.683 21.7456 145.683 21C145.683 20.4408 145.56 19.8816 145.376 19.3846C145.192 18.8876 144.946 18.4527 144.578 18.142C144.21 17.7692 143.78 17.5207 143.35 17.3343C142.859 17.1479 142.307 17.0237 141.754 17.0237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.414 21V22.6154H131.993V23.9201C131.747 24.1065 131.563 24.2929 131.256 24.4793C130.642 24.7899 129.967 24.9763 129.23 24.9763C128.493 24.9763 127.757 24.7899 127.204 24.4793C126.59 24.1686 126.161 23.6716 125.792 23.0503C125.485 22.429 125.301 21.7456 125.301 21C125.301 20.2544 125.485 19.5089 125.792 18.9497C126.099 18.3284 126.59 17.8935 127.204 17.5207C127.818 17.2101 128.493 17.0237 129.23 17.0237C129.783 17.0237 130.335 17.1479 130.826 17.3343C131.256 17.5207 131.686 17.7692 131.993 18.0799L133.589 16.6509C133.036 16.1538 132.423 15.7811 131.686 15.5325C130.949 15.2219 130.09 15.0976 129.23 15.0976C128.309 15.0976 127.511 15.2219 126.713 15.5325C125.976 15.8432 125.301 16.216 124.749 16.7751C124.196 17.3343 123.766 17.9556 123.459 18.639C123.152 19.3846 123.03 20.1923 123.03 21.0621C123.03 21.9319 123.152 22.7396 123.459 23.4231C123.766 24.1686 124.196 24.7899 124.749 25.287C125.301 25.8461 125.976 26.2189 126.713 26.5296C127.45 26.8402 128.309 26.9645 129.23 26.9645C130.151 26.9645 130.949 26.8402 131.686 26.5296C131.747 26.4674 131.87 26.4674 131.931 26.4053C132.545 26.0947 133.159 25.7219 133.65 25.287C133.835 25.1006 134.08 24.8521 134.203 24.6035V20.9379H129.414V21Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5637 25.1627L31.7397 22.3669C31.801 22.3669 31.801 22.3669 31.8624 22.3047C32.2308 22.1805 32.5378 21.9941 32.9061 21.7456C33.827 21.1243 34.3181 20.1923 34.3181 19.0118C34.3181 18.3284 34.1339 17.7071 33.827 17.1479C33.52 16.5888 33.0289 16.1539 32.4764 15.9053C32.0466 15.7189 31.6169 15.5326 31.1257 15.4704C30.6346 15.4083 30.0821 15.3462 29.284 15.3462H25.3549V26.716H27.6264V22.7397H28.9156L33.3972 27.213L34.5637 25.1627ZM31.3099 20.4408C30.8188 20.8136 30.0207 21 29.0384 21H27.6264V17.0237H29.2226C30.0207 17.0237 30.8188 17.0858 31.3099 17.3965C31.801 17.7071 32.108 18.2663 32.108 18.9497C32.108 19.6953 31.8624 20.0681 31.3099 20.4408Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3168 19.1361L45.4915 26.716H48.0699L41.3782 14.8491L34.5637 26.716H37.2035L41.3168 19.1361Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.144 19.1361L169.258 26.716H171.898L165.144 14.8491L158.391 26.716H160.97L165.144 19.1361Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5568 25.1627L19.9524 20.5651L24.434 16.0917L22.715 15.0976L17.3739 20.2544V15.284H15.1638V26.716H17.3739V21.1864L23.3903 27.1509L24.5568 25.1627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6855 25.1627L82.0811 20.5651L86.6241 16.0917L84.8437 15.0976L79.5026 20.2544V15.284H77.2925V26.716H79.5026V21.1864L85.519 27.1509L86.6855 25.1627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_39_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 42
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V42H187V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_39_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.391 25.1627L155.567 22.3669C155.629 22.3669 155.69 22.3669 155.69 22.3047C156.058 22.1805 156.365 21.9941 156.734 21.7456C157.655 21.1243 158.146 20.1923 158.146 19.0118C158.146 18.3284 157.962 17.7071 157.655 17.1479C157.348 16.5888 156.857 16.1539 156.304 15.9053C155.874 15.7189 155.445 15.5326 154.953 15.4704C154.462 15.4083 153.91 15.3462 153.112 15.3462H149.183V26.716H151.454V22.7397H152.743L157.225 27.213L158.391 25.1627ZM155.199 20.4408C154.708 20.8136 153.91 21 152.927 21H151.454V17.0237H153.05C153.848 17.0237 154.646 17.0858 155.138 17.3965C155.629 17.7071 155.936 18.2663 155.936 18.9497C155.936 19.6953 155.69 20.0681 155.199 20.4408Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKrGora);
export default __webpack_public_path__ + "static/media/logo-kr-gora.97687a8808aba437eb75d2bfe3f75a02.svg";
export { ForwardRef as ReactComponent };